export default "assets/images/arion-arrow-ad6dd041.svg";